// extracted by mini-css-extract-plugin
module.exports = {"header":"PseudoTable_header__2naOp","row":"PseudoTable_row___lT2J"};